import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 16 16"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M10.942 4a.7.7 0 0 0-.7.7v6.596a.7.7 0 1 0 1.4 0V4.7a.7.7 0 0 0-.7-.7m-6.367.197a.7.7 0 0 0-.024.99l2.683 2.815-2.683 2.815a.7.7 0 0 0 1.014.966l3.143-3.298a.7.7 0 0 0 0-.966L5.565 4.22a.7.7 0 0 0-.99-.024"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
